module.exports = __webpack_public_path__ + "static/media/game.d58782d0.svg";